import { window } from "global";
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { JOB_POSTINGS } from "./jobPostings";
import { JobPostingRenderer } from "./JobPostingRenderer";
import { SvgArrowLineLeft } from "@ugitgud/legos/ui/icon/SVG/ArrowLineLeft";

const CareersPost = () => {
  const { position } = useParams<{ position: string }>();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const job = JOB_POSTINGS.find((j) => j.slug === position);

  if (!job) {
    return (
      <div className="text-content-container px-6">
        <div className="text-content">
          <h1 className="mb-3">Position Not Found</h1>
          <p className="mb-6">This position no longer exists or the link may be incorrect.</p>
          <Link to={AppRoutes.CAREERS} className="inline-flex items-center text-[16px] text-blue-400 !no-underline">
            <SvgArrowLineLeft className="h-[30px] w-[30px]" /> Back to Careers
          </Link>
        </div>
      </div>
    );
  }

  const { title, department, location, type, content } = job;

  return (
    <div className="text-content-container px-6">
      <div className="text-content">
        <Link to={AppRoutes.CAREERS} className="inline-flex items-center mb-8 text-[16px] !no-underline">
          <SvgArrowLineLeft className="h-[30px] w-[30px]" /> Back to Careers
        </Link>
        <h1 className="mb-3">{title}</h1>
        <div className="flex flex-wrap gap-3 mb-10">
          <span className="rounded-full bg-purple-400 px-3 py-1 text-sm text-gray-400 font-semibold">{department}</span>
          <span className="rounded-full bg-purple-400 px-3 py-1 text-sm text-gray-400 font-semibold">{location}</span>
          <span className="rounded-full bg-purple-400 px-3 py-1 text-sm text-gray-400 font-semibold">{type}</span>
        </div>
        <JobPostingRenderer title={title} content={content} />
        <div className="mt-12 border-t border-gray-700 pt-8">
          <h3 className="text-lg font-semibold mb-3">Ready to apply?</h3>
          <p className="!text-lavender-50 mb-4">
            Send your resume and a brief introduction to{" "}
            <a href="mailto:careers@u.gg" className="text-blue-400 hover:text-blue-300 transition-colors">
              careers@u.gg
            </a>{" "}
            with the subject line <span className="font-semibold text-white">"{title}"</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CareersPost;
